<style lang="scss" rel="stylesheet/scss" scoped>
</style>
<style lang="scss" rel="stylesheet/scss">
#custom-button {
  height: 30px;
  outline: 1px solid grey;
  background-color: green;
  padding: 5px;
  color: white;
}
#card-element {
  border-radius: 4px 4px 0 0;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}
#card-error {
  color: red;
}
/**
 * Extracted from: SweetAlert
 * Modified by: Istiak Tridip
 */
.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;
}
.success-checkmark .check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid #4caf50;
}
.success-checkmark .check-icon::before {
  top: 3px;
  left: -2px;
  width: 30px;
  transform-origin: 100% 50%;
  border-radius: 100px 0 0 100px;
}
.success-checkmark .check-icon::after {
  top: 0;
  left: 30px;
  width: 60px;
  transform-origin: 0 50%;
  border-radius: 0 100px 100px 0;
  animation: rotate-circle 4.25s ease-in;
}
.success-checkmark .check-icon::before,
.success-checkmark .check-icon::after {
  content: "";
  height: 100px;
  position: absolute;
  background: #ffffff;
  transform: rotate(-45deg);
}
.success-checkmark .check-icon .icon-line {
  height: 5px;
  background-color: #4caf50;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}
.success-checkmark .check-icon .icon-line.line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: icon-line-tip 0.75s;
}
.success-checkmark .check-icon .icon-line.line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: icon-line-long 0.75s;
}
.success-checkmark .check-icon .icon-circle {
  top: -4px;
  left: -4px;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  box-sizing: content-box;
  border: 4px solid rgba(76, 175, 80, 0.5);
}
.success-checkmark .check-icon .icon-fix {
  top: 8px;
  width: 5px;
  left: 26px;
  z-index: 1;
  height: 85px;
  position: absolute;
  transform: rotate(-45deg);
  background-color: #ffffff;
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
</style>
<template>
  <div style="">
    <form
      id="sign-in-form"
      @submit.prevent="submitPayment()"
      v-if="pageStatus == 'form'"
    >
      <v-layout row wrap>
        <v-flex xs12>
          <v-flex
            xs12
            style="padding-left: 10px; padding-right: 10px; text-align: center"
          >
            <h3 class="title" v-if="topUpSuccessful">
              Wallet Top Up Successful
            </h3>
            <h3 class="title" v-else>
              {{ paymentPayload.description }}
            </h3>
            <h1>{{ formatPrice(toValue, "GMD") }}</h1>
            <span class="caption"
              >*** Exchange Rate £1.00 to
              {{ formatPrice(exchangeRate, "GMD") }}</span
            >
          </v-flex>

          <template v-if="topUpSuccessful">
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
            <v-btn
              @click="reset()"
              color="info"
              style="width: 100%"
              v-if="type != 'public'"
            >
              {{ paymentPayload.description }}
            </v-btn>
            <v-btn
              v-if="type != 'public'"
              @click="close()"
              color="red"
              class="white--text"
              style="width: 100%"
            >
              Close
            </v-btn>
          </template>

          <template v-else>
            <v-flex xs12>
              <div style="min-height: 65px">
                <v-alert
                  v-if="showError"
                  :value="showError"
                  color="error"
                  icon="warning"
                  outline
                >
                  {{ errorMessage }}
                </v-alert>
                <!-- <span v-else class="caption">Enter Amount And Card Details</span> -->
              </div>
            </v-flex>
            <!-- v-validate="'required'" :error-messages="errors.collect('amount')" -->
            <v-flex xs12 style="padding-left: 10px; padding-right: 10px">
              <v-text-field
                :prefix="currency"
                name="amount"
                v-model="initialBalanceFormatted"
                label="Enter Amount"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 style="padding-left: 10px; padding-right: 10px">
              <div ref="card-element" id="card-element"></div>
            </v-flex>
            <v-flex
              xs12
              style="padding-left: 5px; padding-right: 10px; padding-top: 5px"
            >
              <v-btn
                color="info"
                style="width: 100%"
                v-if="initialBalance && !cardError ? false : true"
                :disabled="true"
                :loading="loading"
              >
                Load Wallet
              </v-btn>
              <v-btn
                v-else
                color="info"
                style="width: 100%"
                type="submit"
                :loading="loading"
              >
                Load {{ formatPrice(initialBalance, "GBP") }}
              </v-btn>
            </v-flex>
          </template>
        </v-flex>
      </v-layout>
    </form>
    <div
      class="text-xs-center"
      v-if="pageStatus == 'loading'"
      style="padding-top: 200px"
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="blue"
        indeterminate
      ></v-progress-circular>
    </div>
  <div v-if="pageStatus == 'error'">
    <v-alert
      :value="true"
      color="error"
      icon="warning"
      outline
    >
      Error : invalid request
    </v-alert>
  </div>
  <div v-if="pageStatus == 'already-processed'">
    <v-alert
      :value="true"
      color="error"
      icon="warning"
      outline
    >
      Error : this request has already been processed.
    </v-alert>
  </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import { loadStripe, stripePublishableKey } from "@/lib/stripe-local";

function formatAsCurrency(value, dec) {
  dec = dec || 0;
  if (!value) {
    return null;
  }
  return Number(value).toFixed(dec);
}

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = "") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    console.log(e);
  }
}

export default {
  name: "top-up",
  props: ["module", "type", "secret"],
  data: function () {
    return {
      pageStatus: null,
      urlPrefix: null,
      payloadSecret: null,
      card: null,
      topUpSuccessful: false,
      showError: false,
      errorMessage: null,
      stripe: null,
      token: null,
      loading: false,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      amountValue: null,
      amount: null,
      cardError: true,
      currency: "£",
      initialBalance: 0.0,
      toValue: 0.0,
      exchangeRate: 66.2,
      amounts: [
        { id: "100", value: 100, service: "electricity" },
        { id: "500", value: 500, service: "electricity" },
        { id: "750", value: 750, service: "electricity" },
        { id: "1000", value: 1000, service: "electricity" },
        { id: "1500", value: 1500, service: "electricity" },
        { id: "2000", value: 2000, service: "electricity" },
      ],
      paymentPayload: {
        type: "topup-wallet",
        description: "Top Up Wallet",
        currency: "gbp",
        items: [
          {
            code: "topup-wallet",
            name: "Top Up Wallet",
            amount: 0.0,
          },
        ],
      },
    };
  },
  components: {},
  computed: {
    initialBalanceFormatted: {
      get: function () {
        return this.initialBalance == 0 ? null : this.initialBalance;
        // return formatAsCurrency(this.initialBalance, 2)
      },
      set: function (setValue) {
        let newValue = setValue;

        try {
          newValue = Number(newValue).toFixed(2);
        } catch (erro) {}

        const initialBalance =
          typeof newValue !== "string"
            ? Number(value).toFixed(2)
            : Number.parseFloat(newValue.replace(/[^0-9\.]/g, ""));
        // console.log(
        //   "newValue.replace(/[^0-9.]/g, '')",
        //   newValue.replace(/[^0-9\.]/g, "")
        // );
        //console.log("initialBalance", initialBalance);
        this.initialBalance = initialBalance;
        const toValue = initialBalance * this.exchangeRate;
        this.toValue = isNaN(toValue) ? 0.0 : toValue;
      },
    },
  },
  methods: {
    reset() {
      this.card = null;
      this.topUpSuccessful = false;
      this.showError = false;
      this.errorMessage = null;
      this.stripe = null;
      this.token = null;
      this.loading = false;
      this.cardNumber = null;
      this.cardExpiry = null;
      this.cardCvc = null;
      this.amountValue = null;
      this.amount = null;
      this.cardError = true;
      this.initialBalance = 0.0;
      this.toValue = 0.0;
    },
    close() {
      try {
        this.reset();
        this.createCardElements();
        this.module.closeDialog();
      } catch (error) {
        // console.log("this.module", this.module);
        // console.log("error", error);
      }
    },
    formatPrice(value, currency) {
      const formatter = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency,
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });

      return formatter.format(value);
    },
    setAmount(item) {
      if (this.amount && this.amount.value == item.value) {
        this.amountValue = null;
        this.amount = null;
      } else {
        this.amount = item;
        // console.log("amount", item);
        this.amountValue = item.value;
      }
    },
    async callDSSHistory() {
      const response = await ApiService.query("/ocr/test/dss/incoming-json");
      console.log(response);
    },
    async createToken() {
      console.log("this.$stripeElements", this.$stripeElements);
      const { token, error } = await this.$stripe.createToken(this.cardNumber);
      if (error) {
        // handle error here
        document.getElementById("card-error").innerHTML = error.message;
        return;
      }
      console.log(token);
      // handle the token
      // send it to your server
    },
    getPayload() {
      this.paymentPayload.items[0].amount = this.initialBalance;
      this.paymentPayload.secret = this.payloadSecret;
      return this.paymentPayload;
    },
    async submitPayment() {
      this.loading = true;
      this.showError = false;
      const that = this;
      try {
        const params = this.getPayload();
        const response = await ApiService.post(
          that.urlPrefix + "/create-payment-intent",
          params
        );
        // console.log("response", response);

        const data = response.data;
        that.payloadSecret = data.secret;
        this.confirmPayment(this.stripe, this.card, data.secret);
      } catch (error) {
        this.showError = true;
        try {
          this.errorMessage = error.response.data.message;
        } catch (e) {
          this.errorMessage = error.message;
        }

        // console.log("error.response", error.response);
        // console.log("error", JSON.stringify(error));
      }

      this.loading = false;

      // ApiService.pos
    },
    confirmPayment(stripe, card, clientSecret) {
      this.loading = true;
      this.showError = false;
      const that = this;
      stripe
        .confirmCardPayment(clientSecret, {
          payment_method: {
            card: card,
          },
        })
        .then(function (result) {
          if (result.error) {
            // Show error to your customer
            // showError(result.error.message);
            console.log(result.error);
            that.showError = true;
            that.errorMessage = result.error.message;
            // alert("error");
          } else {
            // The payment succeeded!
            // orderComplete(result.paymentIntent.id);
            // alert("success");
            // console.log("result", result);
            that.topUpSuccessful = true;
            that.showError = false;
            ApiService.post(
              that.urlPrefix + "/confirm-payment",
              result.paymentIntent
            ).then((r) => {});
          }
        });
    },
    async createCardElements() {
      const stripe = await loadStripe(stripePublishableKey);
      this.stripe = stripe;
      // console.log("stripe", stripe);
      const elements = stripe.elements();

      // Prepare the styles for Elements.
      const style = {
        base: {
          color: "#32325d",
          fontFamily: "Arial, sans-serif",
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#32325d",
          },
        },
        invalid: {
          fontFamily: "Arial, sans-serif",
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };

      const that = this;
      const card = elements.create("card", { style, hidePostalCode: true });
      this.card = card;

      // Mount the Card Element on the page.
      card.mount("#card-element");

      card.on("change", ({ error }) => {
        if (error) {
          that.cardError = true;
        } else {
          that.cardError = false;
        }
      });
    },
    async initialise() {
      if (this.type == "public") {
        this.pageStatus = "loading";
        this.payloadSecret = this.secret;
        const urlPrefix = "/p/pay";
        this.urlPrefix = urlPrefix;

        const response = await ApiService.query(
          `${urlPrefix}/intent/${this.payloadSecret}`
        );

        if (response && response.data && response.data.status == "queued") {
          const data = response.data;
          this.initialBalanceFormatted = this.initialBalance =
            data.loadedAmount;
          this.paymentPayload.description = "Top-Up Wallet - " + data.fullname;
          this.paymentPayload.secret = this.payloadSecret;
          this.createCardElements();
          this.pageStatus = "form";
        } else {
          try {
            if(response.data.status == 'succeeded') {
              this.pageStatus = "already-processed"
              return;
            }

          } catch(error) {

          }
          this.pageStatus = "error";
        }
      } else {
        this.pageStatus = "form";
        this.urlPrefix = "/card";
        this.createCardElements();
      }
    },
  },
  mounted() {
    this.initialise();
    // const style = {
    //   base: {
    //     color: 'black',
    //     fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    //     fontSmoothing: 'antialiased',
    //     fontSize: '14px',
    //     '::placeholder': {
    //       color: '#aab7c4',
    //     },
    //   },
    //   invalid: {
    //     color: '#fa755a',
    //     iconColor: '#fa755a',
    //   },
    // };
    // this.cardNumber = this.$stripeElements.create('cardNumber', { style });
    // this.cardNumber.mount('#card-number');
    // this.cardExpiry = this.$stripeElements.create('cardExpiry', { style });
    // this.cardExpiry.mount('#card-expiry');
    // this.cardCvc = this.$stripeElements.create('cardCvc', { style });
    // this.cardCvc.mount('#card-cvc');

    // let channel = pusher.subscribe('iot-channel');
    // channel.bind('data-received', function(data) {
    //   console.log("data", data);
    //   // app.messages.push(JSON.stringify(data));
    // });
  },
  beforeDestroy() {
    // this.cardNumber.destroy();
    // this.cardExpiry.destroy();
    // this.cardCvc.destroy();
  },
};
</script>